export default __webpack_public_path__ + "static/media/Slide36.b048c64f.PNG";